export default __webpack_public_path__ + "static/media/download (1).b1955a5a.png";